import axios from 'axios';

// Константы для совместимости с HTML
const DATA_ATTR = 'data-tg-form-selection';
const CLASS_ATTR = 'tg-form-selection';
const ATTR = key => `${DATA_ATTR}-${key}`;
const CONTAINER_ATTR = `${DATA_ATTR}-container`;

// Utility helpers
const qs = (root, sel) => root.querySelector(sel);
const qsa = (root, sel) => Array.from(root.querySelectorAll(sel));

class TgFormSelection {
    constructor(root) {
        if (!root) return;
        this.root = root;
        this.api = axios.create({ baseURL: '/api/applications' });
        this.state = {
            experience: null,
            role: null,
            demand: null,
            userId: root.querySelector(`[${DATA_ATTR}-user]`)?.dataset.value || null,
            page: 1,
            fetchingStats: false,
            loadingApp: null,
        };
        this.POLL_INTERVAL = 60_000;
        this._interval = null;
        this.init();
    }

    init() {
        this.cacheElements();
        this.bindEvents();
        this.show(window.__INITIAL_SCREEN__ || 'reg_form_1');
        this.fetchStats();
        this.checkHasApplications();
        this._interval = setInterval(() => this.fetchStats(), this.POLL_INTERVAL);
    }

    cacheElements() {
        const r = this.root;
        this.elements = {
            loader: qs(r, `[${DATA_ATTR}-loader]`),
            applicationsList: qs(r, `.${CLASS_ATTR}__applications-list`),
            templateApp: qs(r, `template[${ATTR('template-application')}]`),
            templatePromo: qs(r, `template[${ATTR('template-application-promo')}]`),
            templateUser: qs(r, `template[${ATTR('template-user')}]`),
            openMyAppsBtn: qs(r, `[${ATTR('open')}="my_applications"]`),
            loadMoreBtn: qs(r, `[${ATTR('load-more')}]`),
            roleButtons: {
                client: qs(r, `[${ATTR('next')}][${ATTR('value')}="client"]`),
                specialist: qs(r, `[${ATTR('next')}][${ATTR('value')}="specialist"]`),
                supervisor: qs(r, `[${ATTR('next')}][${ATTR('value')}="supervisor"]`),
            },
            stats: {
                specialist: qs(r, `[${ATTR('stat')}="specialist"]`),
                client: qs(r, `[${ATTR('stat')}="client"]`),
                supervisor: qs(r, `[${ATTR('stat')}="supervisor"]`),
            },
            appAccessTo: qs(r, `[${DATA_ATTR}-application-access-to]`),
            sessionDemand: qs(r, `[${DATA_ATTR}-session-demand]`),
            referalBtn: qs(r, `[${ATTR('referal-btn')}]`),
            containerSearch: qs(r, `[${ATTR('container-search')}]`),
        };
    }

    bindEvents() {
        // root-level delegation for clicks on next/open/go
        this.root.addEventListener('click', this.onRootClick.bind(this));

        // load more
        if (this.elements.loadMoreBtn) {
            this.elements.loadMoreBtn.addEventListener('click', () => this.loadApplications(false));
        }

        // referal button
        if (this.elements.referalBtn) {
            this.elements.referalBtn.addEventListener('click', this.onReferalClick.bind(this));
        }
    }

    async onReferalClick(e) {
        try {
            const tg = window.Telegram?.WebApp;
            if (!tg) return this.showToast('Telegram WebApp не найден');
            tg.sendData('referral');
            setTimeout(() => tg.close(), 300);
        } catch (err) {
            console.error('referal error', err);
        }
    }

    async onRootClick(e) {
        const btn = e.target.closest(`[${ATTR('next')}], [${ATTR('open')}], [${ATTR('go')}]`);
        if (!btn) return;
        e.preventDefault();

        console.log(btn)
        console.log(btn.hasAttribute(ATTR('go')))


        if (btn.hasAttribute(ATTR('go'))) {

            const go = btn.getAttribute(ATTR('go'));
            if (go === 'chat' && window.__SESSION_DATA__?.sessionId) {
                window.location.href = `/selection/chat?session_id=${encodeURIComponent(window.__SESSION_DATA__.sessionId)}`;
            }
            return;
        }

        if (btn.hasAttribute(ATTR('open'))) {
            const openName = btn.getAttribute(ATTR('open'));
            if (openName === 'application_info') {
                const appId = btn.dataset.appId || btn.closest(`[${CONTAINER_ATTR}]`)?.dataset?.appId;
                await this.show('application_info', { appId });
                return;
            }
            await this.show(openName);
            return;
        }

        if (btn.hasAttribute(ATTR('next'))) {
            const container = btn.closest(`[${CONTAINER_ATTR}]`);
            const screen = container?.getAttribute(CONTAINER_ATTR);
            const value = btn.getAttribute(ATTR('value'));

            if (value) {
                if (screen === 'reg_form_3') this.state.experience = +value;
                if (screen === 'reg_form_4') this.state.role = value;
                if (screen === 'reg_form_5' && value !== 'all') this.state.demand = value;
            }

            // Next map
            let nextScreen = {
                reg_form_1: 'reg_form_2_1',
                reg_form_2_1: 'reg_form_2_2',
                reg_form_2_2: 'reg_form_2_3',
                reg_form_2_3: 'reg_form_3',
                reg_form_3: 'reg_form_4',
                reg_form_4: this.state.role === 'specialist' ? 'reg_form_5' : null,
                reg_form_5: 'main',
            }[screen];

            if (screen === 'reg_form_4' && this.state.role !== 'specialist') {
                await this.submitApplication();
                nextScreen = 'main';
            } else if (screen === 'reg_form_5') {
                await this.submitApplication();
            }

            await this.show(nextScreen || 'main');
        }
    }

    setDisabled(el, on = true) {
        if (!el) return;
        el.disabled = on;
        el.classList.toggle(`${CLASS_ATTR}__container-button--disabled`, on);
    }

    setHidden(el, on = true) {
        if (!el) return;
        if (on) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
    }

    showToast(text) {
        // Replace with your app's toast if available
        alert(text);
    }

    async checkHasApplications() {
        try {
            const [{ data: dataPending }, { data: dataPendingOrActive }] = await Promise.all([
                this.api.get('/has-pending'),
                this.api.get('/has-pending-or-active'),
            ]);

            if (!dataPending.has) this.setHidden(this.elements.containerSearch, true);
            this.setDisabled(this.elements.openMyAppsBtn, !dataPendingOrActive.has);
        } catch (err) {
            console.error('checkHasApplications error', err);
        }
    }

    async submitApplication() {
        try {
            const payload = { role: this.state.role, demand_id: this.state.role === 'specialist' ? this.state.demand : null };
            await this.api.post('', payload);
        } catch (err) {
            if (err.response?.status === 403) {
                const next = err.response.data.next_available_at;
                this.showToast(`Нет доступных слотов. Доступно: ${next || '—'}`);
                if (next) {
                    window.__SESSION_DATA__ = window.__SESSION_DATA__ || {};
                    window.__SESSION_DATA__.next_slot_at = next;
                    await this.show('no_slot');
                }
            }
            throw err;
        }
    }

    async fetchStats() {
        if (this.state.fetchingStats) return;
        this.state.fetchingStats = true;
        try {
            const { data } = await this.api.get('/stats');
            this.elements.stats.specialist.textContent = data.specialist ?? '0';
            this.elements.stats.client.textContent = data.client ?? '0';
            this.elements.stats.supervisor.textContent = data.supervisor ?? '0';

            if (data.supervisor === 0)
            {this.elements.stats.supervisor.classList.add(CLASS_ATTR + '__stat-item-number--empty');}
            if (data.specialist === 0)
            {this.elements.stats.specialist.classList.add(CLASS_ATTR + '__stat-item-number--empty');}
            if (data.client === 0)
            {this.elements.stats.client.classList.add(CLASS_ATTR + '__stat-item-number--empty');}


            const nextAt = data.next_available_at;
            const pickBtn = qs(this.root, `[${ATTR('open')}="reg_form_2_1"]`);
            if (nextAt) {
                this.setDisabled(pickBtn, true);
                const el = qs(this.root, `[${DATA_ATTR}-next-access-text]`);
                if (el) el.textContent = `вам доступно с ${new Date(nextAt).toLocaleDateString('ru')}`;
            } else {
                this.setDisabled(pickBtn, false);
            }
        } catch (err) {
            console.error('fetchStats error', err);
        } finally {
            this.state.fetchingStats = false;
            if (this.elements.loader) this.elements.loader.style.display = 'none';
        }
    }

    async fetchApplicationInfo(appId) {
        try {
            const { data } = await this.api.get(`/${appId}`);
            window.__SESSION_DATA__ = {
                appId,
                sessionId: data.session_id,
                users: data.users,
                access_to: new Date(data.access_to).toLocaleString('ru'),
                demand: data.demand_name,
            };
            return window.__SESSION_DATA__;
        } catch (err) {
            console.error('fetchApplicationInfo error', err);
            throw err;
        }
    }

    async loadApplications(reset = false) {
        if (reset) this.state.page = 1;
        try {
            const { data } = await this.api.get(`?page=${this.state.page}`);
            this.renderApplications(data.items, reset, data.has_more);
            this.state.page++;
        } catch (err) {
            console.error('loadApplications error', err);
        }
    }

    renderApplications(items = [], reset = false, hasMore = false) {
        const list = this.elements.applicationsList;
        const tpl = this.elements.templateApp;
        if (!list || !tpl) return;
        if (reset) list.innerHTML = '';

        items.forEach(item => {
            const clone = document.importNode(tpl.content, true);
            clone.querySelector('[data-date]').textContent = new Date(item.created_at).toLocaleString('ru');
            clone.querySelector('[data-role-text]').textContent = `Роль: ${item.session_role}`;
            clone.querySelector('[data-demand-text]').textContent = `Запрос: ${item.session_demand_name || '—'}`;
            clone.querySelector('[data-status-text]').textContent = `Статус: ${item.session_status}`;

            const container = clone.querySelector(`[${CONTAINER_ATTR}]`) || clone.firstElementChild;
            const isPending = item.status === 'pending';

            if (!isPending) {
                container.setAttribute(ATTR('open'), 'application_info');
                container.dataset.appId = item.id;
                container.classList.remove(`${CLASS_ATTR}__container-button--disabled`);
                container.removeAttribute('aria-disabled');
            } else {
                container.removeAttribute(ATTR('open'));
                delete container.dataset.appId;
                container.classList.add(`${CLASS_ATTR}__container-button--disabled`);
                container.setAttribute('aria-disabled', 'true');
            }

            list.appendChild(clone);
        });

        if (this.elements.loadMoreBtn) {
            this.elements.loadMoreBtn.style.display = hasMore ? '' : 'none';
            if (!hasMore && this.elements.templatePromo) {
                const promo = document.importNode(this.elements.templatePromo.content, true);
                list.appendChild(promo);
                const lastPromo = list.querySelector(`[${ATTR('promo')}]`);
                lastPromo?.addEventListener('click', () => this.show(lastPromo.getAttribute(ATTR('open'))));
            }
        }
    }

    renderSessionUsers(users = []) {
        const container = qs(this.root, `[${CONTAINER_ATTR}="application_info"]`);
        const wrapper = container?.querySelector(`.${CLASS_ATTR}__users`);
        const tpl = this.elements.templateUser;
        if (!wrapper || !tpl) return;
        wrapper.innerHTML = '';

        users.filter(u => !u.self).forEach(u => this.appendUser(u));
        const me = users.find(u => u.self);
        if (me) this.appendUser(me, true);
    }

    appendUser(u, myself = false) {
        const container = qs(this.root, `[${CONTAINER_ATTR}="application_info"]`);
        const wrapper = container.querySelector(`.${CLASS_ATTR}__users`);
        const tpl = this.elements.templateUser;
        const c = document.importNode(tpl.content, true);
        if (myself) c.querySelector('.' + CLASS_ATTR + '__user').classList.add(CLASS_ATTR + '__user--self');
        c.querySelector('[data-user-role]').textContent = u.role;
        c.querySelector('[data-user-login]').textContent = u.telegram || '';
        wrapper.appendChild(c);
    }

    async show(name, opts = {}) {
        qsa(this.root, `[${CONTAINER_ATTR}]`).forEach(c => c.classList.remove(`${CLASS_ATTR}__container--active`));
        const cn = qs(this.root, `[${CONTAINER_ATTR}="${name}"]`);
        if (cn) cn.classList.add(`${CLASS_ATTR}__container--active`);

        if (name === 'reg_form_4') {
            const isExperienced = this.state.experience === 3;
            if (this.elements.roleButtons.supervisor) this.setHidden(this.elements.roleButtons.supervisor, !isExperienced);
        }

        if (name === 'main') {
            await this.fetchStats();
            await this.checkHasApplications();
        }

        if (name === 'my_applications') {
            await this.loadApplications(true);
        }

        if (name === 'application_info') {
            const appId = opts.appId || (cn?.dataset?.appId) || window.__SESSION_DATA?.appId;
            if (appId) {
                if (!this.state.loadingApp || this.state.loadingApp !== appId) {
                    this.state.loadingApp = appId;
                    try {
                        if (this.elements.loader) this.elements.loader.style.display = '';
                        await this.fetchApplicationInfo(appId);
                    } catch (err) {
                        this.showToast('Не удалось загрузить детали заявки');
                        return;
                    } finally {
                        if (this.elements.loader) this.elements.loader.style.display = 'none';
                        this.state.loadingApp = null;
                    }
                }
            }

            const { users = [], access_to, demand } = window.__SESSION_DATA__ || {};
            this.renderSessionUsers(users);
            if (this.elements.appAccessTo) this.elements.appAccessTo.textContent = access_to || '—';
            if (this.elements.sessionDemand) this.elements.sessionDemand.textContent = demand || '—';
        }
    }

    destroy() {
        clearInterval(this._interval);
        // remove listeners if needed
    }
}

// Auto init
const rootNode = document.querySelector(`[${DATA_ATTR }]`);
if (rootNode) new TgFormSelection(rootNode);
